module.exports = __webpack_public_path__ + "static/media/work8.8ef21af9.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/work8.png
// module id = 89
// module chunks = 0